import { HybridLayoutSubFormWrapper } from './HybridLayoutSubForm'
import { HybridLayoutLookupRow } from './hybird-lookup/HybridLayoutLookupRow'
import { HybridLayoutNestedDefaultRow } from './HybridLayoutNestedDefaultRow'
import React from 'react'
import { HybridLayoutParsedRowLayoutMapperPropsType } from './hybridLayout.types'
import { ROW_TYPES } from '../../utils/constants'

export const HybridLayoutParsedRowLayoutMapper: React.FC<HybridLayoutParsedRowLayoutMapperPropsType> =
  React.memo(
    ({
      row,
      fullLayout,
      recordId,
      isAssociated,
      associatedObject,
      formUniqueId,
      refetchTimer,
      refetchLogic,
      openAllAccordions,
      customInRowComponent,
      rootRowIndex,
      rowIndex,
      mode,
      task,
    }) => {
      switch (row?.rowType) {
        case ROW_TYPES.SUB_FORM:
          return (
            <HybridLayoutSubFormWrapper
              row={row}
              recordId={recordId}
              fullLayout={fullLayout}
              isAssociated={isAssociated}
              associatedObject={associatedObject}
              formUniqueId={formUniqueId}
              refetchTimer={refetchTimer}
              refetchLogic={refetchLogic}
              openAllAccordions={openAllAccordions}
              mode={mode}
            />
          )
        case ROW_TYPES.MULTI_LOOKUP:
          return (
            <HybridLayoutLookupRow
              row={row}
              recordId={recordId}
              fullLayout={fullLayout}
              formUniqueId={formUniqueId}
              refetchTimer={refetchTimer}
              refetchLogic={refetchLogic}
              openAllAccordions={openAllAccordions}
              task={task ?? {}}
            />
          )
        case ROW_TYPES.SINGLE_LOOKUP_LISTING:
          return null
        default:
          return (
            <HybridLayoutNestedDefaultRow
              row={row}
              fullLayout={fullLayout}
              isAssociated={isAssociated}
              associatedObject={associatedObject}
              formUniqueId={formUniqueId}
              refetchTimer={refetchTimer}
              refetchLogic={refetchLogic}
              openAllAccordions={openAllAccordions}
              customInRowComponent={customInRowComponent}
              rootRowIndex={rootRowIndex}
              rowIndex={rowIndex}
              mode={mode}
              task={task}
            />
          )
      }
    }
  )
HybridLayoutParsedRowLayoutMapper.displayName =
  'HybridLayoutParsedRowLayoutMapper'
